import { NavLink, useLocation } from "react-router-dom";
import { Home, ListOrdered, Mic, Target, UserCircle2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { useAddSheet } from "@/context/AddSheetContext";
import { TID } from "@/constants/testIds";

export function BottomNav() {
  const { user } = useAuth();
  const { t } = useI18n();
  const { openAdd } = useAddSheet();
  const loc = useLocation();
  if (!user || ["/login", "/signup"].includes(loc.pathname)) return null;
  const sides = [
    { to: "/dashboard", icon: Home, label: t("home"), tid: TID.navDashboard },
    { to: "/transactions", icon: ListOrdered, label: t("transactions"), tid: TID.navTransactions },
    { to: "/budgets", icon: Target, label: t("budgets"), tid: TID.navBudgets },
    { to: "/account", icon: UserCircle2, label: t("account"), tid: TID.navAccount },
  ];
  const [a, b, c, d] = sides;
  return (
    <nav className="fixed bottom-5 inset-x-0 z-40 mx-auto max-w-2xl px-3">
      <div
        className="rounded-3xl px-2 py-2 flex items-center justify-around gap-1 border border-white/60 shadow-[0_10px_40px_-10px_rgba(30,58,138,0.35)]"
        style={{
          background: "rgba(236, 238, 241, 0.55)",
          WebkitBackdropFilter: "blur(24px) saturate(180%)",
          backdropFilter: "blur(24px) saturate(180%)",
        }}
      >
        <NavItem item={a} />
        <NavItem item={b} />
        <button
          data-testid={TID.navAdd}
          onClick={() => openAdd("voice")}
          className="-mt-6 neu-fill-blue text-white rounded-full w-14 h-14 grid place-items-center shadow-lg shadow-blue-900/30 active:scale-95 transition-transform"
          aria-label="voice"
        >
          <Mic className="w-6 h-6" strokeWidth={2.2} />
        </button>
        <NavItem item={c} />
        <NavItem item={d} />
      </div>
    </nav>
  );
}

function NavItem({ item: { to, icon: Icon, label, tid } }) {
  return (
    <NavLink
      to={to}
      end={to === "/dashboard"}
      data-testid={tid}
      className={({ isActive }) =>
        `flex flex-col items-center gap-0.5 rounded-2xl px-3 py-2 text-[10px] font-medium transition-all ${
          isActive ? "neu-inset neu-accent-blue" : "neu-accent-blue hover:opacity-80"
        }`
      }
    >
      <Icon className="w-5 h-5" strokeWidth={2.2} />
      <span>{label}</span>
    </NavLink>
  );
}
